import api from './api';
import { CouponBatch } from '../types';

export interface CreateCouponBatchRequest {
  startNumber: number;
  endNumber: number;
  campaignId: string;
  storeId: string;
}

interface CouponBatchResponse {
  couponBatches: CouponBatch[];
  total: number;
}

export const couponBatchService = {
  async getAllCouponBatches(filters?: {
    campaignId?: string;
    storeId?: string;
    startNumber?: string;
    endNumber?: string;
    page?: number;
    limit?: number;
  }): Promise<CouponBatchResponse> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });
    }
    const response = await api.get(`/coupon-batches?${params.toString()}`);
    return response.data;
  },

  async getCouponBatchById(id: string): Promise<CouponBatch> {
    const response = await api.get(`/coupon-batches/${id}`);
    return response.data;
  },

  async createCouponBatch(couponBatch: CreateCouponBatchRequest): Promise<CouponBatch> {
    const response = await api.post('/coupon-batches', couponBatch);
    return response.data;
  },

  async updateCouponBatch(id: string, couponBatch: Partial<CreateCouponBatchRequest>): Promise<CouponBatch> {
    const response = await api.put(`/coupon-batches/${id}`, couponBatch);
    return response.data;
  },

  async deleteCouponBatch(id: string): Promise<void> {
    await api.delete(`/coupon-batches/${id}`);
  },

  async getCouponBatchesByCampaign(campaignId: string): Promise<CouponBatch[]> {
    const response = await api.get(`/coupon-batches/campaign/${campaignId}`);
    return response.data;
  },

  async getCouponBatchesByStore(storeId: string): Promise<CouponBatch[]> {
    const response = await api.get(`/coupon-batches/store/${storeId}`);
    return response.data;
  }
}; 